"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MongoErrorCodes = exports.MemberTryingToJoinOwnAccountError = exports.MemberExistsError = void 0;
// eslint-disable-next-line max-classes-per-file
class MemberExistsError extends Error {
    constructor(context) {
        super('MEMBER_ALREADY_EXISTS');
        if (context) {
            this.context = context;
        }
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
exports.MemberExistsError = MemberExistsError;
class MemberTryingToJoinOwnAccountError extends Error {
    constructor(context) {
        super('MEMBER_TRYING_TO_JOIN_OWN_ACCOUNT');
        if (context) {
            this.context = context;
        }
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
exports.MemberTryingToJoinOwnAccountError = MemberTryingToJoinOwnAccountError;
var MongoErrorCodes;
(function (MongoErrorCodes) {
    MongoErrorCodes[MongoErrorCodes["MONGO_DUPLICATE_ERROR_CODE"] = 11000] = "MONGO_DUPLICATE_ERROR_CODE";
})(MongoErrorCodes = exports.MongoErrorCodes || (exports.MongoErrorCodes = {}));
//# sourceMappingURL=Errors.js.map